import { useReducer } from 'react'
import moment from 'moment'
import { recordsReducer } from '../recordsReducer'
import { Order, StateForm } from '../types'

export const useRecords = () => {
  const [records, dispatch] = useReducer(recordsReducer, {})

  const initializerRecords = (data: { [orderNumber: string]: Order }) => {
    dispatch({ type: 'initializer', payload: data })
  }

  const saveRecord = (record: Order) => {
    dispatch({ type: 'saveRecord', payload: record })
  }

  const changeStateForm = (values: { id: string; stateForm: StateForm }[]) => {
    dispatch({ type: 'changeStates', payload: values })
  }

  const deleteRecords = (ids: string[]) => {
    if (ids.length === 0) return
    dispatch({ type: 'deleteRecords', payload: ids })
  }

  const getDataByState = (state: StateForm | null): Order[] => {
    const today = moment()
    const sevenDaysAgo = moment().subtract(7, 'days')

    const withinRange = Object.values(records).filter((item) => {
      if (!item.savedAt) return false
      const itemDate = moment(item.savedAt)
      const withinDateRange = itemDate.isBetween(sevenDaysAgo, today, null, '[]')
      if (state !== null) {
        return withinDateRange && item.stateForm === state
      }
      return withinDateRange
    })

    return withinRange.sort((a, b) => moment(b.savedAt).valueOf() - moment(a.savedAt).valueOf())
  }

  const deleteObsoleteRecords = () => {
    const sevenDaysAgo = moment().subtract(7, 'days')
    const obsolete = Object.values(records)
      .filter((item) => item.savedAt && moment(item.savedAt).isBefore(sevenDaysAgo))
      .map((item) => item.orderNumber!)
    deleteRecords(obsolete)
  }

  const getRecordById = (id: string): Order => records[id]!

  return {
    records,
    initializerRecords,
    saveRecord,
    changeStateForm,
    deleteRecords,
    getDataByState,
    deleteObsoleteRecords,
    getRecordById,
  }
}
